import React from 'react';
import './Configuracion.css';
import { Navigate } from 'react-router-dom';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import ConfiguracionSEO from '../../Components/Admin/ConfiguracionSEO/ConfiguracionSEO';
import useAuthUser from '../../Components/useAuthUser';
import Spiner from '../../Components/Admin/Spiner/Spiner';

export default function Configuracion() {
    const { isAdmin, loading } = useAuthUser();

    if (loading) return <Spiner />;
    if (!isAdmin) return <Navigate to="/dashboard" replace />;
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <ConfiguracionSEO />
                </div>
            </section>
        </div>
    );
}
